import { createMutableAction } from '@bimser/core';
import { UPLOAD_RESULT_ACTION } from './actionTypes';
import { UploadManagerResultPayload } from '../entities';

export const uploadResultAction = (data: UploadManagerResultPayload) =>
	createMutableAction(UPLOAD_RESULT_ACTION, data);
